import { render, staticRenderFns } from "./agregarProducto.vue?vue&type=template&id=07accf06&scoped=true&"
import script from "./agregarProducto.vue?vue&type=script&lang=js&"
export * from "./agregarProducto.vue?vue&type=script&lang=js&"
import style0 from "./agregarProducto.vue?vue&type=style&index=0&id=07accf06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07accf06",
  null
  
)

export default component.exports